import types from './types';

const defaultState = {
  open: false,
  fullRows: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.COMPARE_ROWS_MODAL:
      return {
        ...state,
        open: action.state
      };

    case types.GET_FULL_ROWS:
      return { ...state, fullRows: [], isLoading: true };
    case types.GET_FULL_ROWS_SUCCESS:
      action.data.result.sort((a, b) => a.ID - b.ID);
      return {
        ...state,
        fullRows: action.data.result,
        isLoading: false
      };
    case types.GET_FULL_ROWS_FAILURE:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
